<template>
  <div>
    <template v-if="$membershipHasPermissionTo('create forms')">
      <div class="bg-white p-4 rounded border border-gray-400">
        <BaseButton primary @click="setModalCreateVisible(true)"> Add form </BaseButton>
      </div>
    </template>

    <Forms
      :loading="pending"
      :project-uuid="projectId"
      :forms="forms"
      class="mt-4"
      @form-delete="removeForm"
    />

    <template v-if="$membershipHasPermissionTo('create forms')">
      <portal v-if="modalCreateVisible" to="app-dialog">
        <ModalCreate :project-uuid="projectId" @closed="modalCreateVisible = false" />
      </portal>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Forms from '@/components/ProjectForms/FormList.vue';
import ModalCreate from '@/components/ProjectForms/ModalCreate.vue';

export default {
  components: {
    Forms,
    ModalCreate,
  },

  props: {
    accountId: { type: String, required: true },
    projectId: { type: String, required: true },
  },

  data: () => ({
    pending: false,
    modalCreateVisible: false,
  }),

  computed: {
    ...mapState('ui/projectForms', ['ids']),
    ...mapGetters('ui/projectForms', ['forms']),
  },

  created() {
    this.init();
  },

  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },

  methods: {
    ...mapActions('ui/projectForms', {
      loadForms: 'load',
      storeForm: 'store',
      deleteForm: 'destroy',
    }),

    ...mapMutations('ui/projectForms', ['setIds', 'setMeta', 'setLinks']),

    async init() {
      const { projectId } = this;

      this.pending = true;

      try {
        const { formUuids } = await this.loadForms({ projectUuid: projectId });

        if (formUuids.length === 1 && !this.$membershipHasPermissionTo('create forms')) {
          this.$router.replace({
            name: 'accounts.forms.formUuid',
            params: {
              accountId: this.accountId,
              formUuid: formUuids[0],
            },
          });
        } else {
          this.pending = false;
        }
      } catch (error) {
        this.pending = false;
      }
    },

    setModalCreateVisible(bool) {
      this.modalCreateVisible = bool;
    },

    async removeForm(formUuid) {
      const { projectId } = this;

      try {
        await this.deleteForm({ projectUuid: projectId, formUuid });
        this.resetAction();
      } catch (error) {
        //
      }
    },
  },
};
</script>
